import { render, staticRenderFns } from "./movebankcheck.vue?vue&type=template&id=59b6154a&scoped=true&"
import script from "./movebankcheck.vue?vue&type=script&lang=js&"
export * from "./movebankcheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6154a",
  null
  
)

export default component.exports